import { render, staticRenderFns } from "./userConfig.vue?vue&type=template&id=03b74c2e&scoped=true&"
import script from "./userConfig.vue?vue&type=script&lang=js&"
export * from "./userConfig.vue?vue&type=script&lang=js&"
import style0 from "./userConfig.vue?vue&type=style&index=0&id=03b74c2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b74c2e",
  null
  
)

export default component.exports